export default{container:"w_GO",trap:"w_GP"};
